module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/archive-77f2303e165346c11194e4829e9d092f.svg";